export default "__VITE_ASSET__0ddd688f__"